import { createContext } from "react";

const PortalPathTenantContext = createContext<string | null>(null);

export default PortalPathTenantContext;
